"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssToRNStyle = void 0;
const react_native_1 = require("react-native");
const convertStyle_1 = __importDefault(require("../convertStyle"));
const convert_1 = require("./convert");
const mediaQueries_1 = require("./mediaQueries");
function kebab2camel(string) {
    return string.replace(/-./g, x => x.toUpperCase()[1]);
}
function stripSpaces(string) {
    return string.replace(/(calc|max|min|rgb|rgba)\(.*?\)/mg, res => res.replace(/\s/g, ''));
}
function cssToStyle(css) {
    const result = {};
    // Find media queries (We use [\s\S] instead of . because dotall flag (s) is not supported by react-native-windows)
    const cssWithoutMediaQueries = css.replace(/@media([\s\S]*?){[^{}]*}/gmi, res => {
        const { css, isValid } = (0, mediaQueries_1.createMedia)(res);
        const style = cssChunkToStyle(css);
        const mediaQuery = (context) => isValid(context) && style;
        if (!result.media)
            result.media = [];
        result.media.push(mediaQuery);
        return '';
    });
    // Find hover (we don't support hover within media queries) (We use [\s\S] instead of . because dotall flag (s) is not supported by react-native-windows)
    const cssWithoutHover = cssWithoutMediaQueries.replace(/&:hover\s*{([\s\S]*?)}/gmi, res => {
        const hoverInstructions = res.substring(0, res.length - 1).replace(/&:hover\s*{/mi, ''); // We remove the `&:hover {` and `}`
        result.hover = cssChunkToStyle(hoverInstructions);
        return '';
    });
    Object.assign(result, cssChunkToStyle(cssWithoutHover));
    return result;
}
function cssToRNStyle(css, units = {}) {
    const { width, height } = react_native_1.Dimensions.get('window');
    const finalUnits = {
        em: 16,
        '%': 0.01,
        vw: width / 100,
        vh: height / 100,
        vmin: Math.min(width, height) / 100,
        vmax: Math.max(width, height) / 100,
        width: 100,
        height: 100,
        rem: 16,
        px: 1,
        pt: 72 / 96,
        in: 96,
        pc: 9,
        cm: 96 / 2.54,
        mm: 96 / 25.4,
        ...units
    };
    const rnStyle = cssChunkToStyle(css);
    return (0, convertStyle_1.default)(rnStyle, finalUnits);
}
exports.cssToRNStyle = cssToRNStyle;
function cssChunkToStyle(css) {
    const result = {};
    css.split(/\s*;\s*(?!base64)/mg).forEach((entry) => {
        const [rawKey, ...rest] = entry.split(':');
        const rawValue = rest.join(':');
        if (!rawValue)
            return;
        const key = kebab2camel(rawKey.trim());
        const value = stripSpaces(rawValue.trim()); // We need this to correctly read calc() values
        switch (key) {
            case 'border':
                Object.assign(result, (0, convert_1.border)(value));
                break;
            case 'borderTop':
            case 'borderLeft':
            case 'borderRight':
            case 'borderBottom':
            case 'outline':
                Object.assign(result, (0, convert_1.borderLike)(key, value));
                break;
            case 'borderStyle':
            case 'borderColor':
            case 'borderWidth':
                Object.assign(result, (0, convert_1.sideValue)('border', value, key.split('border').pop()));
                break;
            case 'background':
                Object.assign(result, (0, convert_1.background)(value));
                break;
            case 'padding':
            case 'margin':
                Object.assign(result, (0, convert_1.sideValue)(key, value));
                break;
            case 'borderRadius':
                Object.assign(result, (0, convert_1.cornerValue)('border', value, 'Radius'));
                break;
            case 'font':
                Object.assign(result, (0, convert_1.font)(value));
                break;
            case 'textDecoration':
                Object.assign(result, (0, convert_1.textDecoration)(value));
                break;
            case 'placeContent':
                Object.assign(result, (0, convert_1.placeContent)(value));
                break;
            case 'flex':
                Object.assign(result, (0, convert_1.flex)(value));
                break;
            case 'flexFlow':
                Object.assign(result, (0, convert_1.flexFlow)(value));
                break;
            case 'transform':
                Object.assign(result, (0, convert_1.transform)(value));
                break;
            case 'boxShadow':
            case 'textShadow':
                // We need to replace boxShadow by shadow
                Object.assign(result, (0, convert_1.shadow)(key === 'boxShadow' ? 'shadow' : key, value));
                break;
            // Other keys don't require any special treatment
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            default: result[key] = value;
        }
    });
    return result;
}
exports.default = cssToStyle;
